import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type TrackAddMenuOption } from '../types';

export const useTrackClickedFolderUpload = () => {
  const { track } = useAnalyticsUtilities();

  const trackClickedFolderUpload = useCallback(
    (params: TrackAddMenuOption) => {
      track(`Clicked 'Folder Upload'`, params);
    },
    [track],
  );

  return { trackClickedFolderUpload };
};
